module.exports = __webpack_public_path__ + "img/zw.0e758752.svg";